import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import {
    ControlledToggleSwitch,
    Textarea,
} from '../../../Form';
import { isPickleBallSportTypeEvent } from '../../../../utils/events';

const HealthAndSafety = ({ coreUI, formApi, sportTypeId }) => {
    const [selectedProtocols, setSelectedProtocols] = useState([]);

    const tennisEventHealthAndSafetyProtocols = coreUI.types.tms.eventHealthProtocolTypes.filter(protocol => !(/^non-tennis-event/.test(protocol.value)));

    useEffect(() => {
        setSelectedProtocols(formApi.values.healthAndSafetyProtocols);
    }, [formApi.values.healthAndSafetyProtocols]);

    const isPickleballEvent = isPickleBallSportTypeEvent(sportTypeId);

    const addProtocol = protocol => {
        let newSelectedProtocols;
        if (!selectedProtocols.some(selected => selected.id === protocol.id)) {
            newSelectedProtocols = [...selectedProtocols, protocol];
        } else {
            newSelectedProtocols = selectedProtocols.filter(selected => selected.id !== protocol.id);
        }

        formApi.setValue('healthAndSafetyProtocols', newSelectedProtocols);
    };
    let healthAndSafetyProtocolsToDisplay = tennisEventHealthAndSafetyProtocols;

    if (isPickleballEvent) {
        healthAndSafetyProtocolsToDisplay = healthAndSafetyProtocolsToDisplay.filter(protocol => protocol.value !== 'separate-balls');
    }

    // used to sort excluded questions at the bottom
    const healthAndSafetyTypes = healthAndSafetyProtocolsToDisplay;

    return (
        <div className={`w-100 d-flex flex-column`}>
            {healthAndSafetyTypes.map((protocol, index) => (
                <ControlledToggleSwitch
                    key={index}
                    label={protocol.label}
                    formGroupCssClass={`mt16`}
                    id={index}
                    checked={selectedProtocols?.some(selected => selected.id === protocol.id)}
                    onChange={() => addProtocol(protocol)}
                />
            ))}
            <Textarea
                label="Additional Safety Protocols"
                description="These additional safety protocols will be visible on the event description."
                id="additionalSafetyInformation"
                field="additionalSafetyInformation"
                rows="5"
            />
        </div>
    );
};

const mapStateToProps = ({ coreUI }) => ({
    coreUI,
});

export default connect(mapStateToProps)(HealthAndSafety);
